import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-cancel-button',
  imports: [],
  templateUrl: './cancel-button.component.html',
})
export class CancelButtonComponent {
  @Input()
  disabled = false

  @Input()
  text: string;

  @Output()
  onClick = new EventEmitter<void>()
}
